if (!customElements.get('emi-faq')) {
  class EmiFaq extends HTMLElement {
    constructor() {
      super();
      this.details = this.querySelectorAll('[data-emi-faq-item]');
    }

    connectedCallback() {
      this.details.forEach((detail) => {
        detail.addEventListener('toggle', this.handleToggle.bind(this));
      });
    }

    handleToggle(event) {
      const target = event.currentTarget;
      if (!target.open) return;

      this.details.forEach((detail) => {
        if (detail !== target && detail.open) {
          detail.open = false;
        }
      });
    }
  }

  customElements.define('emi-faq', EmiFaq);
}
